import { map, last, isArray } from 'lodash-es'

export function getSearchOptions(data) {
  const tmp = {}
  map(data, (item) => {
    // 替换含参数的title
    let title = item.content
    map(item.params, (it) => title = title.replace(
      `{${it.key}}`, 
      `<span class="text-primary">${it.value}</span>`
    ))

    tmp[item.field] = {
      title,
      meta: item.headline,
      columnName: item.field,
      lists: map(item.options, (list) => ({
        label: list.label,
        value: list.value,
        iconActive: list.logo,
        icon: list.logo_unselected || list.logo,
        next: list.to_field,
      }))
    }
  })

  return tmp
}

export function getProgress(selectedItems, options) {
  const index = selectedItems.length
  let total = index
  const { field } = last(selectedItems) || {}

  if(!field) {
    return 0
  }

  let item = options[field]
  while(item && isArray(item.lists) && item.lists[0]?.next) {
    item = options[item.lists[0].next]
    total += 1
  }
  
  return (index / (total + 1)) * 100
}
